<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
      <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <j-input placeholder="请输入考试名称" v-model="queryParam.examName"></j-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
            >
               <a-range-picker style="width:100%" v-model="lastStudyTimeSt" @change="dateChange"/>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
            >
              <j-dict-select-tag v-model="queryParam.status" placeholder="请选择试卷状态" dictCode="exam_test_status" />
            </a-form-item>
          </a-col>

          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button type="primary" @click="searchReset()" style="margin-left:5px;vertical-align: middle;">重置</a-button>
          <a-button @click="testCreate" type="primary" style="float:right;margin-left:5px"  icon="plus">发布考试</a-button>
        </a-row>
      </a-form>
    </div>
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <!-- <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template> -->

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="publish(record)">发布</a> -->
          <a-popconfirm v-if="record.status==11" title="确定发布吗?" @confirm="() => publish(record)">
            <a>发布</a>
          </a-popconfirm>
          <a-popconfirm v-if="record.status==22" title="确定取消发布吗?" @confirm="() => publish(record)">
            <a>取消发布</a>
          </a-popconfirm>

          <a-divider type="vertical" />
          <a @click="testDetail(record)">科目详情</a>
          <a-divider type="vertical" />
          <a @click="testEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <!-- <test-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TestModal from './modules/TestModal'
  import '@/assets/less/TableExpand.less'
  import JSuperQuery from '@/components/jeecg/JSuperQuery.vue'
  import {changTestStatus} from '@/api/api'

  export default {
    name: "TestList",
    mixins:[JeecgListMixin],
    components: {
      TestModal,
      JSuperQuery
    },
    data () {
      return {
        description: '考试管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'考试名称',
            align:"center",
            dataIndex: 'examName'
          },
          {
            title:'考试类型',
            align:"center",
            dataIndex: 'examType_dictText'
          },
          {
            title:'考试时间',
            align:"center",
            dataIndex: 'limitStartTime',
            customRender:function (text,record) {
              return (<span>{record.limitStartTime} ～
              {record.limitEndTime}</span>)
            }
          },
          
          {
            title:'发布状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          
          // {
          //   title:'建议时长(分钟)',
          //   align:"center",
          //   dataIndex: 'suggestTime'
          // },
          // {
          //   title:'是否允许重复提交，1：允许，2：不允许',
          //   align:"center",
          //   dataIndex: 'allowRepeat'
          // },
          // {
          //   title:'是否允许提前交卷，2：不允许',
          //   align:"center",
          //   dataIndex: 'allowEarlier'
          // },
          // {
          //   title:'试卷做过次数',
          //   align:"center",
          //   dataIndex: 'didCount'
          // },
          {
            title:'更新人',
            align:"center",
            dataIndex: 'createBy_dictText',
            customRender:function (text,record) {
              if (record.updateBy_dictText){
                return record.updateBy_dictText;
              }
              return record.createBy_dictText;
              
            }
          },
          {
            title:'更新时间',
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text,record) {
              if(text){
                return text;
              }
              return record.createTime;
            }
          },
         
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/exercise/elinkxExam/list",
          delete: "/exercise/elinkxExam/delete",
          deleteBatch: "/exercise/elinkxExam/deleteBatch",
          // exportXlsUrl: "/exercise/elinkxExam/exportXls",
          // importExcelUrl: "exercise/elinkxExam/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
        lastStudyTimeSt:[],
      }
    },
    created() {
      //this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      dateChange:function(data,data1){
        console.log(data,data1)
        this.queryParam.limitStartTime = data1[0];
        this.queryParam.limitEndTime = data1[1];
      },
             // 创建试卷
      testCreate() {
        this.$router.push({ path: '/exerciseManage/createTest' })
      },
      // 创建试卷
      testEdit(record) {
        this.$router.push({ path: '/exerciseManage/createTest?id='+record.id })
      },
      // 科目詳情
      testDetail(record) {
        this.$router.push({ path: '/exerciseManage/testDetailEdite?examId='+record.id })
      },
      publish(record) {
        changTestStatus({'id':record.id}).then((res) => {
           if (res.success) {
             this.loadData();
           } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
        })
      },
      // getSuperFieldList(){
      //   let fieldList=[];
      //    fieldList.push({type:'string',value:'examName',text:'考试名称',dictCode:''})
      //    fieldList.push({type:'string',value:'examType',text:'考试类型',dictCode:''})
      //    fieldList.push({type:'date',value:'limitStartTime',text:'时段试卷 开始时间'})
      //    fieldList.push({type:'date',value:'limitEndTime',text:'时段试卷 结束时间'})
      //    fieldList.push({type:'int',value:'status',text:'试卷状态(1:未发布，2：已发布)',dictCode:''})
      //    fieldList.push({type:'string',value:'comment',text:'试卷说明',dictCode:''})
      //    fieldList.push({type:'int',value:'suggestTime',text:'建议时长(分钟)',dictCode:''})
      //    fieldList.push({type:'int',value:'allowRepeat',text:'是否允许重复提交，1：允许，2：不允许',dictCode:''})
      //    fieldList.push({type:'int',value:'allowEarlier',text:'是否允许提前交卷，2：不允许',dictCode:''})
      //    fieldList.push({type:'int',value:'didCount',text:'试卷做过次数',dictCode:''})

      //   this.superFieldList = fieldList
      // }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>